import React, { useContext } from "react";
import { BrowserRouter, Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom";

import Home from "./Admin/Home";
import VerifyUser from "./Admin/VerifyUser";
import "./App.css";
import Dashboard3 from "./BrandOnBoarding/Dashboard/Dashboard";
import HomePage from "./BrandOnBoarding/HomePage/HomePage";
import SettingsList from "./BrandOnBoarding/Settings/SettingsList";
import BrandReport from "./BrandReport";
import AuthComponent from "./Component/AuthComponent/AuthComponent";
import AddReport from "./Component/BasicCardComponent/Reporting/AddReport";
import ComparisonReportingComponent from "./Component/BasicCardComponent/Reporting/ComparisonReportingComponent";
import Reporting from "./Component/BasicCardComponent/Reporting/Reporting";
import Dashboard from "./Component/Dashboard/Dashboard";
import LlmUsageRecordComponent from "./Component/LlmUsageRecord/LlmUsageRecordComponent";
import MonitorSetup from "./Component/MonitoringComponent/MonitorSetup";
import MonitoringReport from "./Component/MonitoringComponent/MonitoringReport";
import PromptCreationComponent from "./Component/PromptCreationComponent/PromptCreationComponent";
import Dashboard2 from "./Component/devDashboard2/Dashboard2";
import AdminLayout from "./Layout/AdminLayout";
import { AuthContext } from "./context/auth-context";
import Actions from "./luminaire/Actions/Actions";
import BrandAudit from "./luminaire/BrandAudit/BrandAudit";
import BuyingJourney from "./luminaire/BuyingJourney/BuyingJourney";
import CategoryDiscovery from "./luminaire/CategoryDiscovery/CategoryDiscovery";
import ContentLayout from "./luminaire/ContentLayout";
import LuminaireDashboard from "./luminaire/Dashboard/Dashboard";
import DiscoveryV2 from "./luminaire/DiscoveryV2/Discovery";
import Discovery from "./luminaire/Discovery/Discovery";
import LuminaireHome from "./luminaire/HomePage/HomePage";
import LLMReporting from "./luminaire/LLMReporting/LLMReporting";
import MetricContentMapping from "./luminaire/MetricContentV2/MetricContent";
import PromptEngine from "./luminaire/PromptEngine/PromptEngine";
import Settings from "./luminaire/Settings/Settings";
import { newVersionAvailableToRefresh } from "./services/apiService";
import PurchaseFunnel from "./luminaire/PurchaseFunnel/PurchaseFunnel";
import Conversations from "./luminaire/Conversations.js/Conversations";

function App() {
  const { token, user, isCurrentUserAdmin } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();

  React.useEffect(() => {
    const interval = setInterval(async () => {
      const token = localStorage.getItem("token");
      if (token) {
        const isNewVersionAvailable = await newVersionAvailableToRefresh();
        if (isNewVersionAvailable) {
          setTimeout(() => {
            window.location.reload(true);
          }, 3000);
        }

      }
    }, 60000);

    // const interval6Sec = setInterval(() => {
    //   if (token && location.pathname === "/luminaire/discovery") {
    //     navigate("/luminaire/discoveryV2", { replace: true });
    //   }
    // }, 6000);

    return () => {
      // clearInterval(interval6Sec);
      clearInterval(interval);
    };
  }, []);


  const renderProtectedElement = (Component, props = {}) => {
    return token && user && user?.is_verified ? (
      <Component {...props} />
    ) : (
      <Navigate to="/login" />
    );
  };

  console.log('test==disoverypath>', user?.is_discoveryOld_disabled)

  const getDiscoveryPath = () =>
    user?.is_discoveryOld_disabled ? "/luminaire/discoveryV2" : "/luminaire/discovery";

  const renderAdminElement = (Component) => {
    return isCurrentUserAdmin ? (
      <Component />
    ) : token ? (
      <Navigate to="/luminaire/discoveryV2" />
    ) : (
      <Navigate to="/login" />
    );
  };

  const renderLoginElement = (Component) => {
    return token && user && user?.is_verified ? (
      <Navigate to="/luminaire/discoveryV2" />
    ) : (
      <Component />
    );
  };

  return (
    <div className="App">

      <Routes>
        {/* <Route
            path="/:focusingArea?"
            element={renderProtectedElement(MainPage)}
          /> */}
        <Route
          path="/"
          element={<Navigate to="/luminaire/discoveryV2" replace />}
        />
        <Route
          path="/add-report"
          element={renderProtectedElement(AddReport)}
        />
        <Route path="/brand-report" element={<BrandReport />} />
        <Route
          path="/llmreportdata"
          element={renderProtectedElement(ComparisonReportingComponent)}
        />
        <Route
          path="/reporting"
          element={renderProtectedElement(Reporting)}
        />
        <Route
          path="/monitors"
          element={renderProtectedElement(MonitorSetup)}
        />
        <Route
          path="/monitoringreport/:id"
          element={renderProtectedElement(MonitoringReport)}
        />
        <Route
          path="/dashboard"
          element={renderProtectedElement(Dashboard)}
        />
        <Route
          path="/dashboard2"
          element={renderProtectedElement(Dashboard2)}
        />
        <Route
          path="/brandonboarding/dashboard"
          element={renderProtectedElement(Dashboard3)}
        />
        <Route
          path="/monitors"
          element={renderProtectedElement(MonitorSetup)}
        />
        <Route
          path="/llmusagerecord"
          element={renderProtectedElement(LlmUsageRecordComponent)}
        />
        <Route
          path="/brandonboarding/settings"
          element={renderProtectedElement(SettingsList)}
        />
        <Route
          path="/brandonboarding/home"
          element={renderProtectedElement(HomePage)}
        />
        <Route
          path="/brandonboarding"
          element={renderProtectedElement(HomePage)}
        />
        <Route
          path="/monitoringreport/:id"
          element={renderProtectedElement(MonitoringReport)}
        />
        <Route
          path="/admin"
          element={renderAdminElement(PromptCreationComponent)}
        />

        <Route path="/luminaire" element={<ContentLayout />}>
          <Route index element={renderProtectedElement(Discovery)} />
          <Route
            path="home"
            element={renderProtectedElement(LuminaireHome)}
          />
          <Route
            path="brand-monitoring"
            element={renderProtectedElement(LuminaireDashboard, {
              key: "brand-monitoring",
            })}
          />
          <Route
            path="product-monitoring"
            element={renderProtectedElement(LuminaireDashboard, {
              key: "product-monitoring",
            })}
          />
          <Route path="actions" element={renderProtectedElement(Actions)} />
          {/* <Route
            path="discovery"
            element={renderProtectedElement(Discovery)}
          /> */}
          {user?.email === "mloguercio@findsdm.it" && <Route
            path="discoveryV1"
            element={renderProtectedElement(Discovery)}
          />}

          <Route
            path="discoveryV2"
            element={renderProtectedElement(DiscoveryV2)}
          />

          <Route
            path="conversations"
            element={renderProtectedElement(Conversations)}
          />

          <Route
            path="buying-journey"
            element={renderProtectedElement(BuyingJourney)}
          />
          <Route
            path="metric-content"
            element={renderProtectedElement(MetricContentMapping)}
          />

          <Route
            path="brand-audit"
            element={renderProtectedElement(BrandAudit)}
          />
          <Route
            path="prompt-engine"
            element={renderProtectedElement(PromptEngine)}
          />

          {/* <Route
              path="buying-journey"
              element={renderProtectedElement(BuyingJourney)}
            /> 

             <Route
              path="category-discovery"
              element={renderProtectedElement(CategoryDiscovery)}
            />  */}

          <Route
            path="llm-reporting"
            element={renderProtectedElement(LLMReporting)}
          />
          {(user?.user_role?.role?.name == "Company admin" ||
            user?.user_role?.role?.name == "Super User") && (
              <Route
                path="settings"
                element={renderProtectedElement(Settings)}
              />
            )}
        </Route>

        <Route path="/login" element={renderLoginElement(AuthComponent)} />
        <Route path="/verify-user" element={<VerifyUser />} />
        {user?.user_role?.role_id === 1 && (
          <Route path="/system" element={<AdminLayout />}>
            <Route path="" element={<Home />} />
          </Route>
        )}
        <Route
          path="*"
          element={<Navigate to="/luminaire/discoveryV2" replace />}
        />
      </Routes>

    </div>
  );
}

export default App;
